import { ProductPriceUsd } from "@features/product/product-price-usd";
import { formatGeneration, getPlatformName } from "@entities/compare/lib";
import Car from "@shared/lib/interfaces/car.interface";
import { getCurrencySymbol } from "@shared/lib/utils";
import { CompareDataGridProps } from "./types";
import classes from "./CompareDataGrid.module.scss";

export const CompareDataGrid = ({ offers, specs }: CompareDataGridProps) => {
    const renderValue = (value: unknown, key: string, offer: Car) => {
        if (value === null || value === undefined) {
            return "-";
        }

        switch (key) {
            case "generation":
                return formatGeneration(offer);
            case "statusId":
                if (typeof value === "number") {
                    return getPlatformName(value);
                }
                break;
            case "price":
                if (typeof value === "number") {
                    return (
                        <>
                            {`${value.toLocaleString("ru-RU")} ${getCurrencySymbol(offer.sourceId)}`}
                            <ProductPriceUsd
                                className={classes["compare-grid__usd"]}
                                priceUsd={offer.priceUsd}
                                price={offer.price}
                                sourceId={offer.sourceId}
                            />
                        </>
                    );
                }
                break;
            case "mileage":
                if (typeof value === "number") {
                    return `${value.toLocaleString("ru-RU")}`;
                }
                break;
            default:
                return String(value);
        }

        return "-";
    };

    return (
        <div className={classes["compare-grid"]}>
            {specs.map((spec) => (
                <div key={spec.key} className={classes["compare-grid__row"]}>
                    <div className={classes["compare-grid__label"]}>{spec.label}</div>
                    <div className={classes["compare-grid__values"]}>
                        {offers.map((offer) => (
                            <div key={offer.id} className={classes["compare-grid__value"]}>
                                {renderValue(offer[spec.key], spec.key, offer)}
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};